<template>
    <div class="construction-select">
        <van-nav-bar
            title="选择施工阶段"
            left-text="更新进度"
            right-text=""
            left-arrow
            @click-left="onClickLeft"
        >
        </van-nav-bar>
        <section>
            <van-search v-model="SearchValue" placeholder="请输入搜索信息" @change="SearchChange"></van-search>
            <ul>
                <li v-for="(item,index) in sgList" :key="index" @click="selectChange(item)">
                    <p>{{ item.name }}</p>
                </li>
            </ul>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            SearchValue: '',
            sgList: [],
            detail: this.$route.params.obj,
            active: this.$route.params.active,
        };
    },
    created() {
        // 获取施工阶段字段list
        this.constructionSelectList();
    },
    methods: {
        selectChange(val) {
            this.$router.isBack = 1;
            this.$router.push({ name: 'monomerDetails', params: { currentProgressinfo: val, obj: this.detail, active: this.active } });
        },
        constructionSelectList() {
            this.$axios
                .get('/interfaceApi/baseinfo/dictionary_config/getlist?parent_code=108&type=1')
                .then(res => {
                    this.sgList = res;
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        SearchChange() {

        },
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.push({ name: 'monomerDetails' });
        },
    },
};
</script>

<style lang="stylus">
    .construction-select
        width 100%
        height 100%
        section
            height calc(100% - 45rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            background #ffffff
            ul
                li
                    height 47rpx
                    border 1px solid rgba(240,240,240,1)
                    line-height 47rpx
                    p
                        margin 0 15rpx
</style>